(ns minorodata.components.sql-console.result-copy
  (:require
   ["papaparse" :as papaparse]
   [applied-science.js-interop :as j]))

(defn csv [headers rows]
  (j/call papaparse :unparse
          (clj->js {:fields headers :data rows})
          #js {:newline "\r\n"}))

(defn tsv [rows]
  (j/call papaparse :unparse
          (clj->js {:data rows})
          #js {:newline "\r\n" :delimiter "\t"}))
